import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((device) => ({
        value: device.id,
        label: device.name || device.serial_number,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("v1/body-worn/devices", { params });

      if (!data.success) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/body-worn/devices/${id}`, params);

      return data;
    },
  },
};
